<h2 mat-dialog-title>Untersuchungsauftrag generieren</h2>

<mat-dialog-content>
    <div *ngIf="loading" style="padding: 24px">Lade Labor-Artikel …</div>

    <div *ngIf="!loading && labore.length === 0" style="padding: 12px">
        Keine offenen Untersuchungsauftrag-Artikel in diesem Befund.
    </div>

    <div *ngIf="!loading && labore.length > 0">
        <p style="margin-bottom: 16px">
            Artikel sind vorausgewählt. Jeder Artikel hat eine eigene Zeile und ein eigenes Formular.
            Die Bestellung bleibt offen – Positionen/Preise folgen mit der Lab-Rechnung.
        </p>

        <table class="ua-labore">
            <thead>
                <tr>
                    <th></th>
                    <th>Labor</th>
                    <th>Untersuchungsformular</th>
                    <th>Artikel</th>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngFor="let labor of labore">
                    <tr>
                        <td class="ua-check">
                            <mat-checkbox [(ngModel)]="labor.selected"></mat-checkbox>
                        </td>
                        <td>{{ labor.lieferant }}</td>
                        <td>
                            <div class="ua-formular" *ngIf="labor.selected">
                                <mat-form-field *ngIf="labor.formulare?.length">
                                    <mat-label>Untersuchungsformular</mat-label>
                                    <mat-select [(ngModel)]="labor.lieferant_dokument_id" (selectionChange)="onFormularChange(labor)">
                                        <mat-option *ngFor="let f of labor.formulare" [value]="f.ld_id">
                                            {{ formularOptionLabel(f) }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <button
                                    *ngIf="labor.lieferant_dokument_id"
                                    mat-icon-button
                                    matTooltip="Formular anzeigen"
                                    type="button"
                                    (click)="previewFormular(labor.lieferant_dokument_id, labor.lieferant)"
                                >
                                    <mat-icon>picture_as_pdf</mat-icon>
                                </button>
                                <span *ngIf="!labor.formulare || labor.formulare.length === 0" class="ua-missing">
                                    Kein Formular am Lieferanten hinterlegt
                                </span>
                            </div>
                        </td>
                        <td>
                            <div *ngFor="let a of labor.artikel" class="ua-artikel">
                                <mat-checkbox [(ngModel)]="a.selected" [disabled]="!labor.selected">
                                    {{ a.artikel }} ({{ a.anzahl }}×)
                                    <span *ngIf="a.notiz"> – {{ a.notiz }}</span>
                                </mat-checkbox>
                            </div>
                        </td>
                    </tr>
                    <tr *ngIf="labor.selected && overlaysFor(labor).length">
                        <td colspan="4" class="ua-fill-cell">

            <div *ngIf="labor.selected && overlaysFor(labor).length" class="ua-pdf-fill">
                <div class="ua-pdf-head">
                    <span class="ua-legend edit">hier schreiben</span>
                    <span class="ua-legend context">wird aus dem Auftrag gefüllt</span>
                    <span class="spacer"></span>
                    <button mat-icon-button type="button" (click)="prevFillPage(labor)" [disabled]="(fillPage[labor.rowKey] || 1) <= 1">
                        <mat-icon>navigate_before</mat-icon>
                    </button>
                    <span>Seite {{ fillPage[labor.rowKey] || 1 }} / {{ fillPageCount[labor.rowKey] || 1 }}</span>
                    <button
                        mat-icon-button
                        type="button"
                        (click)="nextFillPage(labor)"
                        [disabled]="(fillPage[labor.rowKey] || 1) >= (fillPageCount[labor.rowKey] || 1)"
                    >
                        <mat-icon>navigate_next</mat-icon>
                    </button>
                </div>
                <div #pdfHost class="ua-pdf-host" [attr.data-lid]="labor.rowKey">
                    <div *ngIf="fillPdfLoading[labor.rowKey]" class="ua-pdf-hint">PDF wird geladen …</div>
                    <div *ngIf="fillPdfError[labor.rowKey]" class="ua-pdf-hint err">{{ fillPdfError[labor.rowKey] }}</div>
                    <div class="ua-pdf-stage" *ngIf="fillPdfSrc[labor.rowKey]">
                    <pdf-viewer
                        [src]="fillPdfSrc[labor.rowKey]"
                        [page]="fillPage[labor.rowKey] || 1"
                        [show-all]="false"
                        [render-text]="false"
                        [original-size]="false"
                        [fit-to-page]="false"
                        [autoresize]="true"
                        [zoom-scale]="'page-width'"
                        (after-load-complete)="onFillPdfLoad(labor, $event)"
                        (page-rendered)="placeMarks(labor)"
                    ></pdf-viewer>
                    <div class="ua-pdf-marks" [attr.data-tick]="fillLayoutTick">
                        <ng-container *ngFor="let m of overlaysOnPage(labor)">
                            <textarea
                                *ngIf="overlayKind(labor, m) === 'text' && isTextBlock(m)"
                                class="ua-pdf-block"
                                [ngStyle]="fillBlockStyle(labor, m)"
                                [(ngModel)]="labor.formularWerte[m.placeholder]"
                                [attr.placeholder]="overlayLabel(labor, m)"
                                [title]="overlayLabel(labor, m)"
                            ></textarea>
                            <input
                                *ngIf="overlayKind(labor, m) === 'text' && !isTextBlock(m)"
                                class="ua-pdf-input"
                                [ngStyle]="fillLineStyle(labor, m)"
                                [(ngModel)]="labor.formularWerte[m.placeholder]"
                                [attr.placeholder]="overlayLabel(labor, m)"
                                [title]="overlayLabel(labor, m)"
                            />
                            <button
                                *ngIf="overlayKind(labor, m) === 'checkbox'"
                                type="button"
                                class="ua-pdf-check"
                                [class.on]="labor.formularWerte[m.placeholder] === '1'"
                                [ngStyle]="fillMarkerStyle(labor, m)"
                                [title]="overlayLabel(labor, m)"
                                (click)="toggleCheckbox(labor, m.placeholder)"
                            >
                                {{ labor.formularWerte[m.placeholder] === '1' ? 'X' : '' }}
                            </button>
                            <span
                                *ngIf="overlayKind(labor, m) === 'context'"
                                class="ua-pdf-context"
                                [ngStyle]="fillMarkerStyle(labor, m)"
                                >{{ overlayLabel(labor, m) }}</span
                            >
                        </ng-container>
                    </div>
                    </div>
                </div>
            </div>

                    </tr>
                </ng-container>
            </tbody>
        </table>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button type="button" (click)="cancel()">Abbrechen</button>
    <button mat-flat-button color="accent" type="button" [disabled]="!canSubmit()" (click)="submit()">
        Generieren
    </button>
</mat-dialog-actions>
